import React from "react"
import moment from 'moment'
import { Table, Divider, Space, Breadcrumb, Button, Pagination, Modal, message, Row, Col } from "antd"
import { Link } from "react-router-dom"

import { AdminService } from "@/services"
import CommonLayout from "@/common/Layout"

import PackageComponentEditFormModal from "./editFormModal"

class PublicComponentPackageComponentsPageContent extends React.PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      packageLoaded: false,
      package: null,
      componentListLoaded: false,
      componentList: [],
      isCreating: false,
      editingComponent: null
    }
  }

  componentDidMount() {
    this.refreshPackage()
    this.refreshComponentList()
  }

  async refreshPackage() {
    const params = {
      package_id: this.props.packageId
    }
    const response = await AdminService.get_public_component_package_info(params)

    const { status, body: _package } = response.data

    if (status <= 0) {
      return message.error("获取代码包数据失败")
    }

    this.setState({
      packageLoaded: true,
      package: _package
    })
  }

  async refreshComponentList() {
    const { packageId } = this.props
    const params = {
      package_id: packageId,
      page: 1,
      page_size: 5000
    }
    const response = await AdminService.get_public_component_list(params)

    const { status, body } = response.data

    if (status <= 0) {
      return message.error("获取代码包数据失败")
    }

    this.setState({
      componentListLoaded: true,
      componentList: body.components
    })
  }

  async handleSubmitCreateComponent(formData) {
    // console.log("todo handleSubmitCreateComponent", formData)

    const { packageId } = this.props
    const params = {
      package_id: packageId,
      key: formData.key,
      name: formData.name,
      icon_type: formData.iconType
    }

    if (formData.iconFile) {
      params.icon_file = formData.iconFile
    }

    const response = await AdminService.create_public_component(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("创建失败，请稍后重试！")
    }

    this.refreshComponentList()
    this.setState({ isCreating: false })

    message.success("保存成功")
  }

  async handleSubmitUpdateComponent(componentId, formData) {
    // console.log("todo handleSubmitUpdateComponent", componentId, formData)

    const params = {
      component_id: componentId,
      key: formData.key,
      name: formData.name,
      icon_type: formData.iconType
    }

    if (formData.iconFile) {
      params.icon_file = formData.iconFile
    }

    const response = await AdminService.update_public_component(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("保存失败，请稍后重试！")
    }

    this.refreshComponentList()
    this.setState({ editingComponent: null })

    message.success("保存成功")
  }

  handleClickDeleteComponent(component) {
    Modal.confirm({
      title: `确认要删除组件"${component.name}"吗？`,
      content: '删除后将不可恢复，请谨慎操作',
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        // console.log("todo deleteComponent", component)
        const params = {
          component_id: component.id
        }

        const response = await AdminService.delete_public_component(params)
        const { status, body } = response.data
        if (status <= 0) {
          return message.error("删除失败，请稍后重试！")
        }

        this.refreshComponentList()
        message.success("删除成功")
      }
    })
  }

  checkReady() {
    const { packageLoaded, componentListLoaded } = this.state
    return packageLoaded && componentListLoaded
  }

  renderNewModal() {
    const { isCreating } = this.state
    if (!isCreating) return null

    const formData = {}

    return (
      <PackageComponentEditFormModal
        isNew={true}
        title="新建组件"
        formData={formData}
        onCancel={() => this.setState({ isCreating: false })}
        onSubmit={(formData) => this.handleSubmitCreateComponent(formData)}
      />
    )
  }

  renderEditModal() {
    const { editingComponent } = this.state
    if (!editingComponent) return null

    return (
      <PackageComponentEditFormModal
        isNew={false}
        title="编辑组件"
        iconUrl={editingComponent.iconUrl}
        formData={editingComponent}
        onCancel={() => this.setState({ editingComponent: null })}
        onSubmit={(formData) => this.handleSubmitUpdateComponent(editingComponent.id, formData)}
      />
    )
  }

  renderBreadcrumb() {

    const { package: _package } = this.state

    return (
      <div style={{ marginBottom: 20 }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/publicComponents/packages">组件代码包</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{_package.name}<span style={{ fontSize: 12, marginLeft: 4 }}>({_package.key})</span></Breadcrumb.Item>
        </Breadcrumb>
      </div>
    )
  }

  renderComponentsTable() {

    const { componentList } = this.state

    const columns = [
      {
        title: '组件名称',
        dataIndex: 'name',
        key: 'name',
        align: "center"
      },
      {
        title: "组件标识",
        dataIndex: "key",
        key: "key",
        align: "center"
      },
      {
        title: '组件图标',
        dataIndex: 'iconUrl',
        key: 'iconUrl',
        align: "center",
        render: (text, record) => {
          if (record.iconType) {
            return record.iconType
          } else {
            return (
              <img src={text} style={{ maxWidth: "40px", maxHeight: "40px" }} />
            )
          }
        }
      },
      {
        title: '操作',
        key: 'action',
        align: "center",
        render: (text, record) => (
          <Space>
            <a onClick={() => this.setState({ editingComponent: record })} style={{ display: "inline-block" }}>编辑</a>
            <Divider type="vertical" />
            <a onClick={() => this.handleClickDeleteComponent(record)} style={{ display: "inline-block" }}>删除</a>
          </Space>
        )
      },
    ];

    return (
      <Table
        dataSource={componentList}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
    )
  }

  renderPageContent() {

    const ready = this.checkReady()
    if (!ready) return null

    return (
      <React.Fragment>
        {this.renderBreadcrumb()}

        <Row>
          <Col span={16}>
            <h2>组件列表</h2>
          </Col>
          <Col span={8} style={{ textAlign: "right" }}>
            <Button type="primary" onClick={() => this.setState({ isCreating: true })}>新建组件</Button>
          </Col>
        </Row>

        <div style={{ marginBottom: 20 }}>
          {this.renderComponentsTable()}
        </div>

        {this.renderNewModal()}
        {this.renderEditModal()}
      </React.Fragment>
    )
  }

  render() {
    return (
      <CommonLayout selectedMenuKey="publicComponentsPackages" openMenuKeys={["groupPublicComponents"]}>
        {this.renderPageContent()}
      </CommonLayout>
    )
  }
}

class PublicComponentPackageComponentsPage extends React.PureComponent {
  render() {

    const params = new URLSearchParams(window.location.search)
    const packageId = params.get("packageId")

    return (
      <PublicComponentPackageComponentsPageContent
        packageId={packageId}
        key={packageId}
      />
    )
  }
}

export default PublicComponentPackageComponentsPage
